
export default {
  name: 'CommonOnline',
  data() {
    return {
      map: [
        {
          title: '一般在线考试',
        },
      ],
      dataList: [
        require('~/assets/image/scence/assess/example-left.png'),
        require('~/assets/image/scence/assess/example-right.png'),
        require('~/assets/image/scence/assess/example-left-mobile.png'),
        require('~/assets/image/scence/assess/example-right-mobile.png'),
      ],
    }
  },
  computed: {
    title() {
      return this.isMobile ? '全面助力在线考试' : '问卷网全面助力在线考试'
    },
    isMobile() {
      return this.$store.state.isMobile
    },
  },
}
